/**
 * @prettier
 */
export function lessThanZeroToUndefined(value?: number | null): number | undefined {
    if (value && value < 0) {
        return;
    }
    return value as any;
}
